export enum ChannelType {
  CHAT = 1,
  FEED = 2,
}

export const ChannelTypeEnum: Record<ChannelType, string> = {
  [ChannelType.CHAT]: 'チャット型',
  [ChannelType.FEED]: 'フィード型',
};